import React from 'react';
import Events from './Events';
import News from './News';

const Section4 = ()=>{


        const events = {
                        'data': 
                        [
                            {
                                "title":"SDSB Luminites Association Holds Annual Reunion",
                                "img":"./images/home/event1.png",
                                "date":"February 29, 2020",
                                "link":"/"
                            },
                            {
                                "title":"SDSB Alumni Celebrate their 30 Year Association with LUMS",
                                "img":"./images/home/event2.jpeg",
                                "date":"December 29, 2018",
                                "link":"/"
                            },
                            {
                                "title":"SDSB Luminites Association Holds Annual Alumni Reunion",
                                "img":"./images/home/event3.png",
                                "date":" December 30, 2017",
                                "link":"/"
                            }
                        ]
                    };

        const news = {
                        'data': 
                        [
                            {
                                "title":"SDSB Luminites Association Coronavirus Relief Efforts",
                                "img":"./images/home/news1.jpg",
                                "date":"4 May 2020",
                                "link":"/"
                            },
                            {
                                "title":"My Lums Connecting Alumni Around the World",
                                "img":"./images/home/news2.jpg",
                                "date":"4 Jun 29, 2018",
                                "link":"/"
                            },
                            {
                                "title":"Welcomes the Newly Elected Board of Directors and Council Members",
                                "img":"./images/home/news3.jpg",
                                "date":"June 26, 2018",
                                "link":"/"
                            }
                        ]
                    };            


    return(

            <div className="section4">
                <div className="row alumniEventsNews">
                    <div className="col-12 heading">
                        <h2>
                            ALUMNI EVENTS & NEWS
                        </h2>
                    
                      </div>

                      <div className="col-12 p-0">
                        <div className="row blockWrapper">
                        
                        <div className="col-12 heading">
                            <div className="row m-0">
                                <div className="col-12 headingWrap">
                                    <p className="">Events</p>
                                    <div className="line">

                                    </div>
                                </div>
                            </div>
                        </div>


                            <Events eventsData={events} />

                        </div>
                        <div className="row blockWrapper">
                        <div className="col-12 heading">
                            <div className="row m-0">
                                <div className="col-12 headingWrap">
                                    <p className="">News</p>
                                    <div className="line">

                                    </div>
                                </div>
                            </div>
                        </div>
                           
                            <News newsData={news} />

                        </div>
                      </div>
                </div>
            </div>
        );

    }
    
    export default React.memo(Section4);